export function Logo() {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.656 21.1H18.84V43.5H13.656V21.1Z" fill="#F8F8FB" />
            <path d="M45.04 43.5L45.008 30.06L38.416 41.132H36.08L29.52 30.348V43.5H24.656V21.1H28.944L37.328 35.02L45.584 21.1H49.84L49.904 43.5H45.04Z" fill="#8892A7" />
        </svg>
    )
}
